<template>
  <div class="waterTest">
    <el-form
      size="medium"
      inline
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <el-form-item class="r-20" prop="name">
        <el-input
          v-model.trim="queryForm.name"
          placeholder="请输入工单名称"
          @keyup.enter.native="query"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="reset">取消</el-button>
      </el-form-item>
      <div style="margin-bottom:20px">
        <el-button type="primary" @click="addData">新增</el-button>
        <!-- <el-button size="medium" type="danger" @click="delData">删除</el-button> -->
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="waterTestInfo"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
    >
      <el-table-column width="20"></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column
        prop="name"
        label="工单名称"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="deviceName"
        label="设备名称"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="deviceId"
        label="设备id"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="deviceNo"
        label="设备序列号"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="addTime"
        label="开始时间"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="endTime"
        label="结束时间"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="longitude"
        label="经度"
        min-width="90"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="latitude"
        label="纬度"
        min-width="90"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="plate"
        label="车牌号"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="水温_1"
        label="水温_1"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="PH_1"
        label="PH_1"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="氨氮_1"
        label="氨氮_1"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="电导率_1"
        label="电导率_1"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="CODmn_1"
        label="CODmn_1"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="总氮_1"
        label="总氮_1"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="总磷_1"
        label="总磷_1"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="溶解氧_1"
        label="溶解氧_1"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="浊度_1"
        label="浊度_1"
        min-width="80"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="waterPointImagery"
        label="取水点图片"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <el-button type="text" @click="showImg(row, 1)">查看图片</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="timeSwitch"
        label="定时开关"
        min-width="80"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span v-if="row.timeSwitch == 1">开启</span>
          <span v-else-if="row.timeSwitch == 2">关闭</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cameraImagery"
        label="水质反演结果图片"
        min-width="180"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <el-button type="text" @click="showImg(row, 2)">查看图片</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="180" fixed="right">
        <template slot-scope="{ row }">
          <div class="options">
            <el-button
              type="text"
              @click="closeStatus(row, 2)"
              v-if="row.timeSwitch == 1"
              >关闭</el-button
            >
            <el-button
              type="text"
              @click="closeStatus(row, 1)"
              v-else-if="row.timeSwitch == 2"
              >开启</el-button
            >
            <el-button type="text" @click="editorData(row)">修改</el-button>
            <el-button type="text" @click="delData(row)">删除</el-button>
            <el-button type="text" @click="checkHistory(row)"
              >历史数据</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 查看图片 -->
    <el-dialog :title="imgTitle" :visible.sync="showImgFlag" class="img-dialog">
      <ul class="img-list">
        <li v-for="(src, index) in srcList" :key="index">
          <el-image :src="src" :preview-src-list="srcList">
            <div slot="placeholder" class="image-slot">
              加载中
              <span class="dot">...</span>
            </div>
          </el-image>
        </li>
        <!-- <li v-for="src in cameraImagerySrcList"></li> -->
      </ul>
    </el-dialog>
    <!-- 新增/编辑工单 -->
    <el-dialog :title="addOrEditorTitle" :visible.sync="addFlag">
      <el-form
        :rules="addFormRules"
        ref="addFormRef"
        :model="addForm"
        size="mini"
        label-width="100px"
      >
        <el-form-item label="工单名称" prop="name">
          <el-input
            v-model="addForm.name"
            placeholder="请输入工单名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备名称" prop="deviceName">
          <el-select
            v-model="addForm.deviceName"
            placeholder="请选择设备名称"
            @change="getDeviceInfo"
          >
            <el-option
              v-for="item in deviceNameList"
              :key="item.id"
              :label="item.deviceName"
              :value="item.deviceName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经度" prop="longitude">
          <el-input
            v-model="addForm.longitude"
            placeholder="请输入经度"
          ></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="latitude">
          <el-input
            v-model="addForm.latitude"
            placeholder="请输入纬度"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备id" prop="deviceId">
          <el-input
            v-model="addForm.deviceId"
            placeholder="请输入设备id"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="设备序列号" prop="deviceNo">
          <el-input
            v-model="addForm.deviceNo"
            placeholder="请输入设备序列号"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="车牌号" prop="plate">
          <el-input
            v-model="addForm.plate"
            placeholder="请输入车牌号"
          ></el-input>
        </el-form-item>
        <el-form-item label="取水点图片" prop="waterPoint">
          <el-upload
            ref="addImg1Upload"
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            :on-preview="addImg1Preview"
            :on-change="addImg1Change"
            :on-remove="addImg1Remove"
            :on-exceed="handleExceed"
            class="avatar-uploader"
            :file-list="addImg1List"
            accept=".jpg, .jpeg, .png"
            :limit="6"
          >
            <i class="el-icon-plus photos-uploader-icon"></i>
          </el-upload>
          <el-dialog
            :visible.sync="addImg1Flag"
            append-to-body
            class="upload-img"
          >
            <el-image width="100%" :src="addImg1" alt="取水点图片" />
          </el-dialog>
        </el-form-item>
        <el-form-item label="水质反演结果图片" prop="cameraImagery">
          <el-upload
            ref="addImg2Upload"
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            :on-preview="addImg2Preview"
            :on-change="addImg2Change"
            :on-remove="addImg2Remove"
            :on-exceed="handleExceed"
            class="avatar-uploader"
            :file-list="addImg2FileList"
            accept=".jpg, .jpeg, .png"
            :limit="6"
          >
            <i class="el-icon-plus photos-uploader-icon"></i>
          </el-upload>
          <el-dialog
            :visible.sync="addImg2Flag"
            append-to-body
            class="upload-img"
          >
            <el-image width="100%" :src="addImg2" alt="水质反演结果图片" />
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="历史数据"
      :visible.sync="historyFlag"
      class="history-dialog"
    >
      <el-table
        ref="historyTable"
        :data="historyData"
        tooltip-effect="dark"
        style="width: 100%"
        size="mini"
        stripe
        height="560px"
      >
        <el-table-column width="20"></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column
          prop="水温_1"
          label="水温_1"
          min-width="60"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="PH_1"
          label="PH_1"
          min-width="80"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="氨氮_1"
          label="氨氮_1"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="电导率_1"
          label="电导率_1"
          min-width="80"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="CODmn_1"
          label="CODmn_1"
          min-width="80"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="总氮_1"
          label="总氮_1"
          min-width="80"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="总磷_1"
          label="总磷_1"
          min-width="80"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="溶解氧_1"
          label="溶解氧_1"
          min-width="80"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="浊度_1"
          label="浊度_1"
          min-width="60"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="时间"
          label="时间"
          min-width="140"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleHistoryCurrentChange"
        :current-page.sync="historyCurrentPage"
        :page-size="historyLimit"
        layout="total, prev, pager, next, jumper"
        :total="historyTotal"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "WaterTest",
  data() {
    return {
      waterTestInfo: [],
      queryForm: {
        name: "",
        plate: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      historyCurrentPage: 1,
      historyLimit: 10,
      historyTotal: 0,
      addFlag: false,
      editorFlag: false,
      addOrEditorTitle: "新增工单",
      addForm: {
        id: null,
        name: "",
        longitude: "",
        latitude: "",
        deviceName: "",
        deviceId: null,
        deviceNo: "",
        plate: "",
      },
      addFormRules: {
        deviceName: [
          {
            required: true,
            trigger: "change",
            message: "请选择设备名称",
          },
        ],
      },
      deviceNameList: [],
      addImg1: "",
      addImg2: "",
      addImg1Flag: false,
      addImg2Flag: false,
      addImg1List: [],
      addImg1FileList: [],
      addImg2List: [],
      srcList: [],
      addImg2FileList: [],
      waterPointSrcList: [],
      cameraImagerySrcList: [],
      imgTitle: "查看图片",
      showImgFlag: false,
      historyData: [],
      historyFlag: false,
      deviceId: null,
      addTime: "",
      endTime: "",
    };
  },
  created() {
    this.query();
  },
  methods: {
    showImg(row, type) {
      if (type === 1) {
        this.imgTitle='查看取水点图片'
        this.srcList = row.waterPointImageryList;
        this.showImgFlag = row.waterPointImageryList.length > 0 ? true : false;
        if (!this.showImgFlag) this.$message.warning("未查询到数据！");
      } else if (type === 2) {
        this.imgTitle='查看水质反演结果图片'
        this.srcList = row.cameraImageryList;
        this.showImgFlag = row.cameraImageryList.length > 0 ? true : false;
        if (!this.showImgFlag) this.$message.warning("未查询到数据！");
      } else {
        this.showImgFlag = false;
        this.$message.warning("未查询到数据！");
      }
    },
    addImg1Preview(file) {
      this.addImg1 = file.url;
      this.addImg1Flag = true;
    },
    addImg1Change(file, fileList) {
      this.addImg1FileList.push(file);
      // 筛选掉格式不正常的文件
      this.uploadImage(file, fileList, this.addImg1FileList);
    },
    addImg1Remove(file) {
      this.deleteFile(file, this.addImg1FileList);
    },
    addImg2Preview(file) {
      this.addImg2 = file.url;
      this.addImg2Flag = true;
    },
    addImg2Change(file, fileList) {
      this.addImg2FileList.push(file);
      // 筛选掉格式不正常的文件
      this.uploadImage(file, fileList, this.addImg2FileList);
    },
    addImg2Remove(file) {
      this.deleteFile(file, this.addImg2FileList);
    },
    // 处理超出数量限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制上传 6 张图片，已上传 ${fileList.length} 张`
      );
    },
    // 判断上传的是否为图片和限制图片格式
    uploadImage(file, fileList, uploadList) {
      const img = file.name.substring(file.name.lastIndexOf(".") + 1);
      // const isLt1M = file.size / 1024 / 1024 < 2;
      if (img != "jpg" && img != "png" && img != "jpeg") {
        this.$message.error("请上传正确的图片格式!");
        this.deleteFile(file, fileList);
        this.deleteFile(file, uploadList);
        return false;
      }
      // // 可以限制图片的大小
      // if (!isLt1M) {
      //   this.$message.error("上传图片大小不能超过2MB!");
      //   this.deleteFile(file, fileList);
      //   this.deleteFile(file, uploadList);
      // }
    },
    // 删除图片文件
    deleteFile(file, fileList) {
      for (let i in fileList) {
        // 上传的这个file匹配到上传列表中的img，这一项不满足要求需要删除
        if (file == fileList[i]) {
          fileList.splice(i, 1);
        }
      }
    },
    query() {
      this.getWaterTestData();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getWaterTestData();
    },
    async addData() {
      this.editorFlag = false;
      // 清空表单数据
      this.addForm=this.$options.data().addForm;
      this.$resetForm(this, "addFormRef");
      // 清空文件数据
      if (this.$refs.addImg1Upload) {
        this.$refs.addImg1Upload.clearFiles();
      }
      if (this.$refs.addImg2Upload) {
        this.$refs.addImg2Upload.clearFiles();
      }
      this.addImg1FileList = [];
      this.addImg2FileList = [];
      this.addOrEditorTitle = "新增工单";
      await this.getDeviceNameList();
      this.addFlag = true;
    },
    async editorData(row) {
      // 打开编辑状态
      this.editorFlag = true;
      // 清空表单数据
      this.addForm=this.$options.data().addForm;
      // 赋值
      this.addOrEditorTitle = "修改工单";
      this.addForm = JSON.parse(JSON.stringify(row));
      // 处理显示文件列表数据
      this.addImg1List = [...this.handleFileShow(row.waterPointImageryList, 1)];
      this.addImg2List = [...this.handleFileShow(row.cameraImageryList, 2)];
      this.addImg1FileList = [...this.addImg1List];
      this.addImg2FileList = [...this.addImg2List];
      await this.getDeviceNameList();
      setTimeout(() => {
        // 打开编辑弹框
        this.addFlag = true;
      }, 1000);
    },
    // 处理显示文件列表数据
    handleFileShow(fileList, type) {
      let imgList = [];
      let name = "";
      fileList.map((item, index) => {
        name = item.substring(item.lastIndexOf("/") + 1);
        imgList.push({
          name: name,
          url: item,
          index: index,
          status: "success",
          type: type,
        });
      });
      return imgList;
    },
    delData(row) {
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let { data: res } = await this.$axios.delete(
          `/api/water/detection?id=${row.id}`
        );
        if (res.code == 1) {
          this.$message.success("操作成功");
          let totalPage = Math.ceil((this.total - 1) / 10);
          let currentPage =
            this.currentPage > totalPage ? totalPage : this.currentPage;
          this.currentPage = currentPage < 1 ? 1 : currentPage;
          this.getWaterTestData();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    async checkHistory(row, val) {
      let page = val ? val : 1;
      this.historyCurrentPage = page;
      this.deviceId = row.deviceId;
      this.addTime = row.addTime;
      this.endTime = row.endTime;
      let paramsObj = {
        deviceId: row.deviceId,
        addTime: row.addTime,
        endTime: row.endTime,
        page: page,
        limit: 10,
      };
      let { data: res } = await this.$axios.get(
        "/api/water/detection/waterdetails",
        {
          params: paramsObj,
        }
      );
      if (res.code == 1) {
        this.historyFlag = true;
        this.historyData = res.data.list;
        this.historyTotal = res.data.totalCount;
      } else {
        this.$message.warning(res.msg);
      }
    },
    saveOrUpdate() {
      let data = {};
      console.log(this.addForm);
      this.$refs.addFormRef.validate(async (valid) => {
        if (valid) {
          let addObj = new FormData();
          addObj.append("id", this.addForm.id);
          addObj.append("name", this.addForm.name);
          addObj.append("longitude", this.addForm.longitude);
          addObj.append("latitude", this.addForm.latitude);
          this.addImg1FileList.forEach((item) => {
            if (item.raw) {
              addObj.append("waterPoint", item.raw);
            } else {
              addObj.append("waterPoint", null);
            }
          });
          this.addImg2FileList.forEach((item) => {
            addObj.append("camera", item.raw);
          });
          if (this.editorFlag) {
            // 编辑
            data = await this.$axios.patch(
              "/api/water/detection/update",
              addObj
            );
          } else {
            addObj.append("deviceName", this.addForm.deviceName);
            addObj.append("deviceId", this.addForm.deviceId);
            addObj.append("deviceNo", this.addForm.deviceNo);
            addObj.append("plate", this.addForm.plate);
            data = await this.$axios.post("/api/water/detection/save", addObj);
          }
          let res = data.data;
          if (res.code == 1) {
            this.addFlag = false;
            this.$resetForm(this, "addFormRef");
            this.getWaterTestData();
            this.$message.success("操作成功");
          } else {
            this.$message.warning(res.msg);
          }
        }
      });
    },
    getDeviceInfo(value) {
      // 选中设备名称，赋值设备id & 设备序列号
      this.deviceNameList.forEach((item) => {
        if (item.id == value) {
          this.addForm.deviceId = item.id;
          this.addForm.deviceNo = item.deviceNo;
        }
      });
    },
    async getDeviceNameList() {
      let { data: res } = await this.$axios.get(
        "/api/water/detection/getDeviceList"
      );
      if (res.code == 1) {
        this.deviceNameList = res.data.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 修改定时开关状态
    async closeStatus(row, state) {
      let { data: res } = await this.$axios.get(
        "/api/water/detection/closeTask?id=" + row.id + "&timeSwitch=" + state
      );
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.getWaterTestData();
      } else {
        this.$message.warning(res.msg);
      }
    },
    async getWaterTestData() {
      let obj = {};
      obj.name = this.queryForm.name;
      obj.plate = this.queryForm.plate;
      obj.page = this.currentPage;
      obj.limit = this.limit;
      let { data: res } = await this.$axios.get("/api/water/detection/list", {
        params: obj,
      });
      if (res.code == 1) {
        this.waterTestInfo = this.handleWaterTestInfo(res.data.list);
        this.total = res.data.totalCount;
      } else {
        this.$message.warning(res.msg);
      }
    },
    handleWaterTestInfo(list) {
      let waterTestInfo = [];
      let newList = [];
      waterTestInfo = list.map((item) => {
        newList = item.list.map((ele) => {
          return {
            [ele.sensorname]: `${ele.value}${ele.unit}`,
          };
        });
        let mergedSensors = Object.assign({}, ...newList);
        return { ...item, ...mergedSensors };
      });
      return waterTestInfo;
    },
    //页数改变时触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getWaterTestData();
    },
    //页数改变时触发
    handleHistoryCurrentChange(val) {
      let obj = {
        deviceId: this.deviceId,
        addTime: this.addTime,
        endTime: this.endTime,
        page: val,
        limit: this.historyLimit,
      };
      this.historyCurrentPage = val;
      this.checkHistory(obj, val);
    },
  },
};
</script>
<style lang="scss" scoped>
.waterTest {
  height: calc(100% - 40px);
  margin: 20px;
  padding: 0 20px;
  background-color: #fff;
  .top {
    font-size: 16px;
    font-weight: 600;
    margin: 10px 0;
    padding-left: 20px;
  }
  .content-data {
    width: 100%;
    height: calc(100% - 34px);

    background-color: #fff;

    .table {
      width: 80%;
      border: 1px solid #b1b7bc;
      border-bottom: none;
      border-right: none;

      /deep/ .el-row {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #b1b7bc;
        border-right: 1px solid #b1b7bc;
      }

      :not(.blue) {
        padding-left: 10px;
      }

      .blue {
        text-align: center;
        background-color: #d0e4f9;
      }
    }
  }
  /deep/ .el-dialog {
    min-width: 680px;
    .el-dialog__body {
      max-height: 640px;
      min-height: 400px;
      overflow-y: scroll;
      padding-bottom: 0;
      .el-form-item__content {
        width: 420px;
        .avatar-uploader {
          width: 500px;
          img {
            object-fit: cover;
          }
        }
      }
      label[for="waterPoint"],
      label[for="cameraImagery"] {
        width: 100% !important;
        text-align: left;
        padding-left: 20px;
      }
      .img-list {
        margin-bottom: 20px;
      }
    }
  }
  .history-dialog {
    /deep/ .el-dialog {
      min-width: 980px;
      .el-dialog__body {
        padding: 20px;
      }
    }
  }
}
.upload-img {
  /deep/ .el-dialog__body {
    padding: 30px 20px 20px 20px !important;
  }
}
</style>
